import React, { FC } from 'react';

import { ReactComponent as Arrow } from 'assets/images/arrow.svg';

interface Props {
    text?: string;
    onClick?: () => void;
    type?: string;
}

const Button: FC<Props> = ({ text, onClick, type = 'button' }) => {
    if (!text) return null;

    return (
        // @ts-ignore
        // eslint-disable-next-line react/button-has-type
        <button type={type} className="button" onClick={onClick}>
            {text}
            <Arrow className="button__arrow" />
        </button>
    );
};

export default Button;
